let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7UChg")).then(() => parcelRequire('awf0r'));